import request from '@/utils/request'
import type { LoginParams, UserApiRes, UserQuickLoginApiRes } from './types'

export function userLoginApi(data: LoginParams) {
  return request<UserApiRes>({
    url: 'user/login',
    method: 'POST',
    data,
  })
}

export function userCheckFormDataApi(data: { username: string; nickname: string }) {
  return request<UserQuickLoginApiRes>({
    url: 'user/checkFormData',
    method: 'POST',
    data,
  })
}

export function userRegisterApi(data: LoginParams) {
  return request<UserApiRes>({
    url: 'user/register',
    method: 'POST',
    data,
  })
}

export function userQuickLoginApi(data: { nickname: string }) {
  return request<UserQuickLoginApiRes>({
    url: 'user/quickLogin',
    method: 'POST',
    data,
  })
}

export function userTokenApi() {
  return request<UserApiRes>({
    url: 'user/token',
    method: 'POST',
  })
}
